// src/pages/NewsManagement/AddNews.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateNewsMutation } from "../../redux/services/newsService/news.Services";

function AddNews() {
    const navigate = useNavigate();
    const [createNews, { isLoading }] = useCreateNewsMutation();
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        category: "",
        author: "",
        status: "draft",
        publish_date: "",
        meta_title: "",
        meta_description: "",
        meta_keywords: "",
        is_featured: false,
        is_breaking: false,
        image: null
    });
    const [previewImage, setPreviewImage] = useState(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({
                ...formData,
                image: file
            });
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.title.trim()) {
            errorToast("News title is required");
            return;
        }
        if (!formData.description.trim()) {
            errorToast("Description is required");
            return;
        }

        try {
            const formDataToSend = new FormData();
            Object.keys(formData).forEach((key) => {
                if (key === 'image' && formData.image) {
                    formDataToSend.append('image', formData.image);
                } else if (key !== 'image') {
                    formDataToSend.append(key, formData[key]);
                }
            });

            const response = await createNews(formDataToSend).unwrap();
            successToast(response?.message || "News Created Successfully");
            navigate("/news");
        } catch (error) {
            console.log(error);
            errorToast(error?.data?.message || "Failed To Create News");
        }
    };

    return (
        <div>
            {/* HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">Add News</h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">Add News</li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate("/news")}
                    >
                        <i className="fe fe-list me-1"></i>
                        News List
                    </button>
                </div>
            </div>

            {/* FORM */}
            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            {/* Title */}
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>
                                        News Title <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter News Title"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        required
                                        autoFocus
                                    />
                                </div>
                            </div>

                            {/* Category */}
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Category</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Category (e.g., Politics, Sports)"
                                        name="category"
                                        value={formData.category}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Description */}
                            <div className="col-md-12 mt-3">
                                <div className="form-group">
                                    <label>
                                        Description <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter News Description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        rows="5"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Author */}
                            <div className="col-md-4 mt-3">
                                <div className="form-group">
                                    <label>Author</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Author Name"
                                        name="author"
                                        value={formData.author}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Status */}
                            <div className="col-md-4 mt-3">
                                <div className="form-group">
                                    <label>Status</label>
                                    <select
                                        name="status"
                                        className="form-control"
                                        value={formData.status}
                                        onChange={handleChange}
                                    >
                                        <option value="draft">Draft</option>
                                        <option value="published">Published</option>
                                        <option value="archived">Archived</option>
                                    </select>
                                </div>
                            </div>

                            {/* Publish Date */}
                            <div className="col-md-4 mt-3">
                                <div className="form-group">
                                    <label>Publish Date</label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        name="publish_date"
                                        value={formData.publish_date}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Meta Title */}
                            <div className="col-md-6 mt-3">
                                <div className="form-group">
                                    <label>Meta Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Meta Title"
                                        name="meta_title"
                                        value={formData.meta_title}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Meta Description */}
                            <div className="col-md-6 mt-3">
                                <div className="form-group">
                                    <label>Meta Description</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Meta Description"
                                        name="meta_description"
                                        value={formData.meta_description}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Meta Keywords */}
                            <div className="col-md-12 mt-3">
                                <div className="form-group">
                                    <label>Meta Keywords</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Meta Keywords (comma separated)"
                                        name="meta_keywords"
                                        value={formData.meta_keywords}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Image Upload */}
                            <div className="col-md-6 mt-3">
                                <div className="form-group">
                                    <label>News Image</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="image"
                                        onChange={handleFileChange}
                                        accept="image/*"
                                    />
                                </div>
                            </div>

                            {/* Checkboxes */}
                            <div className="col-md-6 mt-3">
                                <div className="form-group">
                                    <label>Options</label>
                                    <div className="d-flex gap-4 mt-2">
                                        <label className="d-flex align-items-center gap-2">
                                            <input
                                                type="checkbox"
                                                name="is_featured"
                                                checked={formData.is_featured}
                                                onChange={handleChange}
                                            />
                                            Featured News
                                        </label>
                                        <label className="d-flex align-items-center gap-2">
                                            <input
                                                type="checkbox"
                                                name="is_breaking"
                                                checked={formData.is_breaking}
                                                onChange={handleChange}
                                            />
                                            Breaking News
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* Image Preview */}
                            {previewImage && (
                                <div className="col-md-12 mt-3">
                                    <div className="form-group">
                                        <label>Image Preview</label>
                                        <div>
                                            <img 
                                                src={previewImage} 
                                                alt="News Preview" 
                                                style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }}
                                                className="img-thumbnail"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Submit Button */}
                            <div className="col-md-12 mt-4">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Creating...
                                        </>
                                    ) : (
                                        "Create News"
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddNews;